import { render, staticRenderFns } from "./ChatRelated.vue?vue&type=template&id=0f16d4a6&"
import script from "./ChatRelated.vue?vue&type=script&lang=js&"
export * from "./ChatRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports